import React from 'react'
import { NumberText } from '../../../Global'

export const TableDataCellCarts = ({ dataValue }: { dataValue?: number }) => {
  return <NumberText value={Number(dataValue)} />
}
